import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { ModalHeader, ModalSubHeader } from './common';
import { memo } from 'react';
import { useTranslation } from 'next-i18next';

export type TokenVerificationFailedContentProps = {
  onClose: () => void;
};

export const TokenVerificationFailedContent = memo(() => {
  const { t } = useTranslation('user-settings');
  const header = t('email_verification_failed_header');

  return (
    <div className="flex flex-col items-center">
      <Image src={getAssetSrc('/utils-assets/warning.svg')} width={64} height={64} alt={header} />
      <div className="my-2 ">
        <ModalHeader>{header}</ModalHeader>
      </div>
      <div className="mb-10">
        <ModalSubHeader>{t('email_verification_failed_subheader')}</ModalSubHeader>
      </div>
    </div>
  );
});
